import { ActivatedRouteSnapshot } from "@angular/router";
import {
  readNavReturnFromParam,
  resolveNavReturnLabelFromQuery,
} from "src/app/shared/helpers/nav-return.helper";
import {
  DEFAULT_KNOWLEDGE_BASE_RETURN,
  KNOWLEDGE_BASE_RETURN_STATE_KEY,
  KnowledgeBaseReturnContext,
} from "./knowledge-base.model";

const RETURN_LABEL_KEY_BY_PATH: Record<string, string> = {
  "/dashboard": "knowledge_base.return.dashboard",
  "/help/faqs": "knowledge_base.return.faqs",
  "/usage-overview": "knowledge_base.return.billing",
  "/initial-setup/candidate-claims-found":
    "knowledge_base.return.candidate_claims_search",
};

export function resolveReturnLabelKeyFromUrl(returnUrl: string): string {
  const path = returnUrl.split("?")[0].split("#")[0];

  if (RETURN_LABEL_KEY_BY_PATH[path]) {
    return RETURN_LABEL_KEY_BY_PATH[path];
  }

  if (path === "/" || path.startsWith("/landing")) {
    return "knowledge_base.return.landing";
  }

  if (path.startsWith("/help")) {
    return "knowledge_base.return.help";
  }

  if (path.startsWith("/report")) {
    return "knowledge_base.return.reports";
  }

  return DEFAULT_KNOWLEDGE_BASE_RETURN.labelKey;
}

export function resolveKnowledgeBaseReturnContext(
  route: ActivatedRouteSnapshot,
): KnowledgeBaseReturnContext {
  const stateReturn = history.state?.[KNOWLEDGE_BASE_RETURN_STATE_KEY] as
    | KnowledgeBaseReturnContext
    | undefined;

  const queryReturnUrl = route.queryParamMap.get("returnUrl");
  const queryReturnLabelKey = route.queryParamMap.get("returnLabelKey");
  const fromLabel = resolveNavReturnLabelFromQuery(
    readNavReturnFromParam(route),
    "knowledge_base",
  );

  if (queryReturnUrl) {
    return {
      url: queryReturnUrl,
      labelKey:
        queryReturnLabelKey ??
        fromLabel ??
        stateReturn?.labelKey ??
        resolveReturnLabelKeyFromUrl(queryReturnUrl),
    };
  }

  const returnUrl = stateReturn?.url ?? DEFAULT_KNOWLEDGE_BASE_RETURN.url;
  const labelKey =
    stateReturn?.labelKey ?? resolveReturnLabelKeyFromUrl(returnUrl);

  return { url: returnUrl, labelKey };
}
